import type { PublicCollectionModel } from "@/features/collections/api/models/PublicCollectionModel";
import type { Currency } from "@/lib/domain/Currency";
import type { PriceSource } from "@/lib/domain/PriceSource";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export const usePublicCollection = (shareToken: string, currency: Currency, priceSource: PriceSource) => {
	const http = useHTTP("UseIfPresent");
	return useHTTPQuery({
		queryKey: ["publicCollection", shareToken, currency, priceSource],
		queryFn: () => {
			return http<PublicCollectionModel>({
				method: "GET",
				url: `/collection/public/${shareToken}?currency=${currency}&priceSource=${priceSource}`
			});
		}
	});
};
